import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'vpfa-small-subtitle-extra',
  templateUrl: './small-subtitle-extra.component.html',
  styleUrls: ['./small-subtitle-extra.component.scss']
})
export class SmallSubtitleExtraComponent implements OnInit {

  @Input() text = null;

  constructor() { }

  ngOnInit() {
  }

}
